import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderArtifactsUploadConstraints: build.query<
      GetV2ProviderArtifactsUploadConstraintsApiResponse,
      GetV2ProviderArtifactsUploadConstraintsApiArg
    >({
      query: () => ({ url: `/v2/provider/artifacts/upload-constraints` }),
    }),
    deleteV2ProviderArtifactsByArtifactId: build.mutation<
      DeleteV2ProviderArtifactsByArtifactIdApiResponse,
      DeleteV2ProviderArtifactsByArtifactIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/artifacts/${queryArg.artifactId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderArtifactsByArtifactId: build.query<
      GetV2ProviderArtifactsByArtifactIdApiResponse,
      GetV2ProviderArtifactsByArtifactIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/artifacts/${queryArg.artifactId}`,
      }),
    }),
    getV2ProviderArtifactsByArtifactIdDownloadUrl: build.query<
      GetV2ProviderArtifactsByArtifactIdDownloadUrlApiResponse,
      GetV2ProviderArtifactsByArtifactIdDownloadUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/artifacts/${queryArg.artifactId}/download-url`,
      }),
    }),
    postV2ProviderOrganizationsByOrganizationIdArtifacts: build.mutation<
      PostV2ProviderOrganizationsByOrganizationIdArtifactsApiResponse,
      PostV2ProviderOrganizationsByOrganizationIdArtifactsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/${queryArg.organizationId}/artifacts`,
        method: "POST",
      }),
    }),
    getV2ProviderOrganizationsByOrganizationIdArtifactsEvents: build.query<
      GetV2ProviderOrganizationsByOrganizationIdArtifactsEventsApiResponse,
      GetV2ProviderOrganizationsByOrganizationIdArtifactsEventsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/${queryArg.organizationId}/artifacts/events`,
      }),
    }),
    getV2ProviderPatientsByPatientIdArtifacts: build.query<
      GetV2ProviderPatientsByPatientIdArtifactsApiResponse,
      GetV2ProviderPatientsByPatientIdArtifactsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/artifacts`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          source_channel: queryArg.sourceChannel,
          sensitivity_level: queryArg.sensitivityLevel,
          artifact_kind: queryArg.artifactKind,
          artifact_batch_id: queryArg.artifactBatchId,
        },
      }),
    }),
    postV2ProviderPatientsByPatientIdArtifacts: build.mutation<
      PostV2ProviderPatientsByPatientIdArtifactsApiResponse,
      PostV2ProviderPatientsByPatientIdArtifactsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/artifacts`,
        method: "POST",
      }),
    }),
    getV2ProviderPatientsByPatientIdArtifactsEvents: build.query<
      GetV2ProviderPatientsByPatientIdArtifactsEventsApiResponse,
      GetV2ProviderPatientsByPatientIdArtifactsEventsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/artifacts/events`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderArtifactsUploadConstraintsApiResponse =
  /** status 200 OK */ ArtifactUploadConstraintsResponse;
export type GetV2ProviderArtifactsUploadConstraintsApiArg = void;
export type DeleteV2ProviderArtifactsByArtifactIdApiResponse = unknown;
export type DeleteV2ProviderArtifactsByArtifactIdApiArg = {
  artifactId: string;
};
export type GetV2ProviderArtifactsByArtifactIdApiResponse =
  /** status 200 OK */ ArtifactDetailResponse;
export type GetV2ProviderArtifactsByArtifactIdApiArg = {
  artifactId: string;
};
export type GetV2ProviderArtifactsByArtifactIdDownloadUrlApiResponse =
  /** status 200 OK */ ArtifactDownloadUrlResponse;
export type GetV2ProviderArtifactsByArtifactIdDownloadUrlApiArg = {
  artifactId: string;
};
export type PostV2ProviderOrganizationsByOrganizationIdArtifactsApiResponse =
  /** status 200 OK */ ArtifactUploadResponse;
export type PostV2ProviderOrganizationsByOrganizationIdArtifactsApiArg = {
  organizationId: string;
};
export type GetV2ProviderOrganizationsByOrganizationIdArtifactsEventsApiResponse =
  unknown;
export type GetV2ProviderOrganizationsByOrganizationIdArtifactsEventsApiArg = {
  organizationId: string;
};
export type GetV2ProviderPatientsByPatientIdArtifactsApiResponse =
  /** status 200 OK */ ArtifactListResponse;
export type GetV2ProviderPatientsByPatientIdArtifactsApiArg = {
  patientId: string;
  /** Max results per page */
  limit?: number;
  /** Offset for pagination */
  offset?: number;
  /** Filter by one or more source channels. Repeat for OR semantics. */
  sourceChannel?: string[] | null;
  /** Filter by sensitivity level (unrestricted | phi_standard | sud_treatment | psychotherapy_note). */
  sensitivityLevel?: string[] | null;
  /** Filter by file-format category (pdf, docx, pptx, image, audio, video, archive, other). Repeat for OR semantics. */
  artifactKind?: string[] | null;
  /** Restrict to artifacts in a specific batch. */
  artifactBatchId?: string | null;
};
export type PostV2ProviderPatientsByPatientIdArtifactsApiResponse =
  /** status 200 OK */ ArtifactUploadResponse;
export type PostV2ProviderPatientsByPatientIdArtifactsApiArg = {
  patientId: string;
};
export type GetV2ProviderPatientsByPatientIdArtifactsEventsApiResponse =
  unknown;
export type GetV2ProviderPatientsByPatientIdArtifactsEventsApiArg = {
  patientId: string;
};
export type ArtifactUploadConstraintsResponse = {
  /** MIME types the artifact pipeline accepts */
  allowed_content_types: string[];
  /** Maximum per-file size in bytes */
  max_file_size_bytes: number;
  /** Maximum page count for PDF uploads (ignored for images) */
  max_pdf_pages: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ArtifactFileInfo = {
  content_type?: string | null;
  original_filename?: string | null;
  page_count?: number | null;
  size_bytes?: number | null;
};
export type ArtifactProcessingInfo = {
  error?: string | null;
  normalized_content_s3_key?: string | null;
  ocr_quality?: number | null;
  parse_job_id?: string | null;
  parsed_content_s3_key?: string | null;
  patient_match_confidence?: number | null;
  stages_completed?: string[];
};
export type ArtifactMetadata = {
  extra?: {
    [key: string]: any;
  };
  file?: ArtifactFileInfo;
  language?: string;
  processing?: ArtifactProcessingInfo;
};
export type ArtifactDetailResponse = {
  artifact_batch_id?: string | null;
  artifact_id: string;
  artifact_kind?: string | null;
  content_type?: string | null;
  created_at: string;
  metadata?: ArtifactMetadata;
  organization_id: string;
  original_filename?: string | null;
  page_count?: number | null;
  patient_id?: string | null;
  processing_status: string;
  scope: string;
  sensitivity_level?: string | null;
  size_bytes?: number | null;
  source_channel?: string;
  supersedes_artifact_id?: string | null;
  updated_at: string;
};
export type ArtifactDownloadUrlResponse = {
  expires_in: number;
  url: string;
};
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type ArtifactSummaryResponse = {
  artifact_batch_id?: string | null;
  artifact_id: string;
  artifact_kind?: string | null;
  content_type?: string | null;
  created_at: string;
  organization_id: string;
  original_filename?: string | null;
  page_count?: number | null;
  patient_id?: string | null;
  processing_status: string;
  scope: string;
  sensitivity_level?: string | null;
  size_bytes?: number | null;
  source_channel?: string;
  supersedes_artifact_id?: string | null;
  updated_at: string;
};
export type ArtifactUploadResponse = {
  artifact_batch_id?: string | null;
  artifacts: ArtifactSummaryResponse[];
};
export type ArtifactSummaryResponse2 = {
  artifact_batch_id?: string | null;
  artifact_id: string;
  artifact_kind?: string | null;
  content_type?: string | null;
  created_at: string;
  organization_id: string;
  original_filename?: string | null;
  page_count?: number | null;
  patient_id?: string | null;
  processing_status: string;
  scope: string;
  sensitivity_level?: string | null;
  size_bytes?: number | null;
  source_channel?: string;
  supersedes_artifact_id?: string | null;
  updated_at: string;
};
export type ArtifactDuplicateEntry = {
  existing_artifact_id: string;
  filename: string;
  message: string;
};
export type ArtifactUploadConflictResponse = {
  artifact_batch_id?: string | null;
  artifacts: ArtifactSummaryResponse2[];
  duplicates: ArtifactDuplicateEntry[];
};
export type ArtifactSummaryResponse3 = {
  artifact_batch_id?: string | null;
  artifact_id: string;
  artifact_kind?: string | null;
  content_type?: string | null;
  created_at: string;
  organization_id: string;
  original_filename?: string | null;
  page_count?: number | null;
  patient_id?: string | null;
  processing_status: string;
  scope: string;
  sensitivity_level?: string | null;
  size_bytes?: number | null;
  source_channel?: string;
  supersedes_artifact_id?: string | null;
  updated_at: string;
};
export type ArtifactListResponse = {
  items: ArtifactSummaryResponse3[];
  limit: number;
  offset: number;
  total: number;
};
